export default __webpack_public_path__ + "static/media/WeatherApp.e40a5c33.png";